const changePasswordStr = {
  toastr: 'Senha alterada',
  toastr1: 'senha alterada com sucesso',
  toastrError: 'Senha incorreta',
  toastrError1: 'A senha antiga não confere'
};

export default changePasswordStr;
